import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { ApolloProvider, graphql } from "react-apollo";
import { ToastContainer } from "react-toastify";
import { IntlProvider } from "react-intl";
import { useIntl } from "react-intl";
import ReactDOM from "react-dom";
import _ from "lodash";
import { apolloClient, AppContext, withContext, QUERY_ME } from "./context";

import "./App.scss";
import { getTranslation, getCookie, setCookie } from "./utils";
import GenericModal from "./components/Modal/GenericModal";

const Loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/Pages/Login"));
const Page404 = React.lazy(() => import("./views/Pages/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500"));

const isValidSeller = (isAgent, me) => {
  const { companies = [] } = me;
  let isBlock = false;
  for (let company of companies) {
    if (["pending", "suspended"].includes(company.status) || !company.inContract) {
      isBlock = true;
    }
  }
  return isBlock && !isAgent;
};

@graphql(QUERY_ME)
class AppContextProvider extends React.PureComponent {
  render() {
    const {
      data: { loading, me },
      switchLang,
      locale
    } = this.props;
    const isAdmin = _.includes(me && me.roles, "admin");
    const isAgent = isAdmin || _.includes(me && me.roles, "agent");
    const isEnterprise = !!_.find(me && me.companies, o => o.plan === "enterprise");
    if (loading) return <Loading />;
    return <AppContext.Provider value={{ me, isAdmin, isAgent, isEnterprise, switchLang, locale }}>{this.props.children}</AppContext.Provider>;
  }
}

const Admin = withContext(props => {
  const { isAgent, me, location } = props;
  if (!props.me) {
    return <Redirect to={"/login?redirect=" + location.pathname + location.search} />;
  }
  if (isValidSeller(isAgent, me)) return <WarningInvalidSeller />;
  return <DefaultLayout {...props} />;
});

const WarningInvalidSeller = () => {
  const intl = useIntl();
  return ReactDOM.createPortal(
    <GenericModal open title="Note">
      <div className="mt-2 gray-color">{intl.formatMessage({ id: "messageBlockSeller" })}</div>
      <div className="mt-2 gray-color">Tel: +81 50 5578 0494</div>
      <div className="mt-2 gray-color">
        E-mail: <strong className="strong-color">ask@carfromjapan.com</strong>
      </div>
    </GenericModal>,
    document.getElementsByTagName("body")[0]
  );
};

class App extends Component {
  state = {
    locale: getCookie("language") || "en"
  };
  switchLang = locale => {
    setCookie("language", locale);
    this.setState({ locale });
  };
  render() {
    const { locale } = this.state;
    const fileTranslation = getTranslation({ locale });
    return (
      <IntlProvider locale={locale} messages={fileTranslation} onError={() => {}}>
        <ApolloProvider client={apolloClient}>
          <ToastContainer />
          <AppContextProvider switchLang={this.switchLang} locale={locale}>
            <BrowserRouter>
              <React.Suspense fallback={<Loading />}>
                <Switch>
                  <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
                  <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
                  <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
                  <Route path="/" name="Home" render={Admin} />
                </Switch>
              </React.Suspense>
            </BrowserRouter>
          </AppContextProvider>
        </ApolloProvider>
      </IntlProvider>
    );
  }
}

export default App;
